import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useIsAreasAdmin, useSelectedCompanyDetails, useShowAreaFeature, useUser } from '@hooks';
import { t } from '@i18n';
import { BoxContainer, FullWidthContent, MainMenuLayout } from '@layouts';
import { SelectAreas, SelectCustomerCard } from '@organisms';
import FileDispersion from './FileDispersion';

/** File Dispersion screen */
const FileDispersionsScreen = () => {
  const [isLoading, setLoading] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const { data } = useSelectedCompanyDetails();
  const { user } = useUser();
  const { isAreasAdmin } = useIsAreasAdmin();
  const { showAreaFeature } = useShowAreaFeature();

  useEffect(() => {
    setSelectedArea(null);
  }, [data, setSelectedArea]);
  return (
    <MainMenuLayout>
      <FullWidthContent>
        <SelectCustomerCard disabled={isLoading} />
        {showAreaFeature && (
          <BoxContainer>
            <Typography variant='h4'>{t('COMMON:AREA_LABEL')}</Typography>
            <SelectAreas
              value={selectedArea}
              onChange={(_event, value) => {
                setSelectedArea(value.id);
              }}
              customerId={user.isInternal && data?.id}
              disabled={user.isInternal && !data?.id}
              optionWithoutAreas={isAreasAdmin}
              placeholder='COMMON:SELECT_AREA'
            />
          </BoxContainer>
        )}
        <FileDispersion
          isLoading={isLoading}
          setLoading={setLoading}
          data={data}
          selectedArea={selectedArea}
        />
      </FullWidthContent>
    </MainMenuLayout>
  );
};

export default FileDispersionsScreen;
